import { WSService } from "../../../../utils/WSService";

export const statementsService = new WSService("/v2/banking");
